import { useRouteLoaderData } from 'react-router-dom';
import { useMemo } from 'react';
import { paths } from '@mosey/api-types';
import { getDecodedAccessToken } from '@mosey/utils/auth';
import { getImpersonatedUser } from '../utils/impersonation';

type MeResponse =
  paths['/api/users/me']['post']['responses']['200']['content']['application/json'];
type LegalEntityToDoCountResponse =
  paths['/api/compliance/tasks/counts/{task_status}']['get']['responses']['200']['content']['application/json'];

export const useUserLoaderData = () => {
  return useRouteLoaderData('user') as {
    user: MeResponse;
    legalEntityToDoCounts: Promise<LegalEntityToDoCountResponse>;
  };
};

export const useUser = () => {
  const { user } = useUserLoaderData();

  return user;
};

export const useIsPlatformUser = () => {
  const { is_platform_user: isPlatformUser } = useUser();

  return isPlatformUser;
};

export const usePlatform = () => {
  const {
    legal_entity: { platform },
  } = useUser();

  return platform;
};

export const useLegalEntitiesToDoCounts = () => {
  const { legalEntityToDoCounts } = useUserLoaderData();

  return legalEntityToDoCounts;
};

export const useLegalEntityRegions = () => {
  const {
    legal_entity: { regions },
  } = useUser();

  return useMemo(() => {
    return regions.sort((a, b) => a.name.localeCompare(b.name));
  }, [regions]);
};

export const useImpersonationUser = () => {
  const decodedAccessToken = getDecodedAccessToken();
  return getImpersonatedUser(decodedAccessToken);
};
